import TextField from "../../fields/textField/TextField.vue";
import TextAreaField from "../../fields/textAreaField/TextAreaField.vue";
import PerfilService from "../../../services/PerfilService";
import { SnackbarMixin } from "../../../mixins/snackbarMixin";

export default {
  name: "ConfirmPasswordDialog",

  components: {
    TextAreaField,
    TextField,
  },

  mixins: [SnackbarMixin],

  props: {
    activeDialog: {
      default: false,
      type: Boolean,
    },

    vModelPassword: {
      required: true,
      type: String,
    },
  },

  data: () => ({
    showPassword: false,
    dialog: false,
    formValid: true,
    valuePassword: null,
  }),

  beforeMount() {
    this.valuePassword = this.vModelPassword;
  },

  watch: {
    activeDialog() {
      this.showPassword = false;
      this.$refs.form.resetValidation();
      this.dialog = !this.dialog;
    },

    valuePassword(input) {
      this.$emit("inputPassword", input);
    },

    vModelPassword(input) {
      this.valuePassword = input;
    },
  },
  methods: {
    close() {
      this.$emit("closed");
      this.dialog = false;
    },

    async send() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        formData.append("password", this.valuePassword);
        formData.append("justificativa", this.valueJustificativa);

        const response = await PerfilService.validaAssinatura(formData);

        if (response.error) {
          const responseMenssage = await response.response;
          this.showSnackbar(responseMenssage, "error");
          return;
        }
        this.$emit("send");
        this.close();
      }
    },
  },
};
